module.exports = __webpack_public_path__ + "static/media/download.a89dde06.png";